import CustomRoute from '../CustomRoute/CustomRoute'

export default function NoNav({ match, location }) {
  console.log('NoNav rendered', match, location)

  return (
    <CustomRoute match={match} location={location} />
  )
}